<template>
  <v-row 
    align="start" 
    no-gutters 
    class="sideBySideToolbar secondary">
    <v-col>
      <side-by-side-image-annotation-controls
        :zoomControlSize="leftZoomControlSize"
        :zoomControlFit="leftZoomControlFit"
        :transform="leftTransform"
        :context="sideBySideLeftContext"
        :syncContext="sideBySideRightContext"
        :isLeft="true"
        @updateZoom="$emit('updateZoom', true, $event)"
        @zoomToFit="$emit('zoomToFit', true)"
        @updateCenter="$emit('updateCenter', true, $event)"
        @syncAnnotations="syncAnnotations()"/>
    </v-col>
    <v-btn
      text
      class="syncButton mx-1 d-none d-lg-block primary modal-cta"
      :class="[{active: sideBySideIsSynced}, colorClass]"
      :disabled="!sideBySideCanSync"
      @click="syncAnnotations">Sync</v-btn>
    <v-col>
      <side-by-side-image-annotation-controls
        :zoomControlSize="rightZoomControlSize"
        :zoomControlFit="rightZoomControlFit"
        :transform="rightTransform"
        :context="sideBySideRightContext"
        :syncContext="sideBySideLeftContext"
        :isLeft="false"
        @updateZoom="$emit('updateZoom', false, $event)"
        @zoomToFit="$emit('zoomToFit', false)"
        @updateCenter="$emit('updateCenter', false, $event)"/>
    </v-col>
  </v-row>
</template>

<script>
import sideBySideImageAnnotationControls from "./SideBySideImageAnnotationControls";
import { mapGetters } from "vuex";
export default {
  name: "sideBySideBrowserAnnotationBar",
  components: { sideBySideImageAnnotationControls },
  props: [
    "leftZoomControlSize",
    "leftZoomControlFit",
    "leftTransform",
    "rightZoomControlSize",
    "rightZoomControlFit",
    "rightTransform"
  ],
  computed: {
    ...mapGetters([
      "sideBySideLeftContext",
      "sideBySideRightContext",
      "sideBySideIsSynced",
      "sideBySideCanSync",
    ])
  },
  methods: {
    syncAnnotations() {
      this.$store.commit("toggleSideBySideSync");
      if (this.sideBySideIsSynced) this.$store.commit("syncAnnotations");
      else this.$store.commit("desyncAnnotations");
    }
  }
};
</script>
